import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Grid, CircularProgress
} from '@mui/material';
import { updateTrialDateApi } from 'backendServices/ApiCalls';

const UpdateTrialModal = ({ open, onClose, userId, GetUsersList, trialEnd, closeMain, setalertData }) => {
  const [formData, setFormData] = useState({
    trial_end: '',
    admin_transaction_password: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Helper to convert unix timestamp in seconds to YYYY-MM-DD
  const unixToDateString = (unixTimestamp) => {
    if (!unixTimestamp) return "";
    const date = new Date(unixTimestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper to convert YYYY-MM-DD to unix timestamp at 12:00am (00:00:00) local time
  const convertToMidnightUnix = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day, 0, 0, 0, 0);
    return Math.floor(date.getTime() / 1000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.trial_end) {
      tempErrors.trial_end = "Date is required";
    }
    if (!formData.admin_transaction_password) {
      tempErrors.admin_transaction_password = "Transaction password is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setLoading(true);

    const unixTime = convertToMidnightUnix(formData.trial_end);
    const apiPayload = {
      dateTime: unixTime,
      admin_transaction_password: formData.admin_transaction_password,
      id: userId
    };
    console.log(apiPayload)

    try {
      updateTrialDateApi(apiPayload, (response) => {
        if (response?.data?.status === "error") {
          setalertData({
            show: true,
            message: response?.data?.message || "Error updating trial date",
            variant: "error"
          });
        } else {
          setalertData({
            show: true,
            message: "Trial date updated successfully",
            variant: "success"
          });
          onClose();
          closeMain();
          GetUsersList();
        }
        setLoading(false);
      }, (error) => {
        setalertData({
          show: true,
          message: error?.response?.data?.message || "Something went wrong please try again later",
          variant: "error"
        });
        setLoading(false);
      });
    } catch (error) {
      setalertData({
        show: true,
        message: "Something went wrong please try again later",
        variant: "error"
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      setFormData({
        trial_end: '',
        admin_transaction_password: ""
      });
      setErrors({});
    } else {
      if (trialEnd) {
        setFormData((prev) => ({
          ...prev,
          trial_end: unixToDateString(trialEnd)
        }));
      }
    }
  }, [open, trialEnd]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Trial Date</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              type="date"
              label="Trial End Date"
              name="trial_end"
              value={formData.trial_end}
              onChange={handleChange}
              error={!!errors.trial_end}
              helperText={errors.trial_end}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              label="Transaction Password"
              name="admin_transaction_password"
              type="password"
              value={formData.admin_transaction_password}
              onChange={handleChange}
              error={!!errors.admin_transaction_password}
              helperText={errors.admin_transaction_password}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateTrialModal;
